<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('pending_fabric_plan_detail_search') ||
                  '面料编号/面料显示名称搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="form" label-position="right" size="small">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.order_form_label_fabric_no') || '面料编号'">
                <el-input v-model.trim="form.fabricNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_fabricDisplayName') || '面料显示名称'"
              >
                <el-input
                  v-model.trim="form.fabricDisplayName"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'">
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="form.scmCode"
                  :body="{}"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_isSpecify') || '客户指定供应商'"
              >
                <br />
                <el-checkbox-group v-model="form.isSpecifyList">
                  <el-checkbox label="Y">{{
                    $l("INDEX.YES") || "是"
                  }}</el-checkbox>
                  <el-checkbox label="N">{{
                    $l("INDEX.NO") || "否"
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l("INDEX.btn_cancel_query") || "取消查询"
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l("INDEX.btn_reset_filter") || "重置条件"
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l("INDEX.btn_data_retrieval") || "数据检索"
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: "",
  isSpecifyList: ["Y", "N"],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    //初始查询
    query() {
      this.$emit("query", this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
